import {Component, Input} from '@angular/core';

@Component({
  selector: 'webu-product-tag',
  templateUrl: './product-tag.component.html'
})
export class ProductTagComponent {
  @Input () productTag: string;
}
